import { useMutation } from '@tanstack/react-query';
import { toast } from 'react-toastify';
import { updateExpense } from '../api/expensesApi';

export default function useUpdateExpense() {
    return useMutation({
        mutationFn: ({ id, body }) => updateExpense(id, body),
        onSuccess: () => toast.success('Expense updated'),
        onError: (err) => toast.error(err?.message ?? 'Failed to update expense'),
    });
}
